<template>
  <div>
    <div class="col-xs-6">
      <div class="color-gray-light-mid weight-lighter size-16">
        <i class="fa fa-calendar"></i>
        Check In:
      </div>
      <p class="_mb-0 size-18">{{ start | dateToWeekday }}</p>
      <p class="_mb-0 size-14">ás {{ start | dateToHour }}</p>
    </div>
    <div class="col-xs-6">
      <div class="color-gray-light-mid weight-lighter size-16">
        <i class="fa fa-calendar"></i>
        Check Out:
      </div>
      <p class="_mb-0 size-18">{{ end | dateToWeekday }}</p>
      <p class="_mb-0 size-14">ás {{ end | dateToHour }}</p>
    </div>
  </div>
</template>

<script>
import { dateToWeekday } from '@/filters/datetime'

export default {
  filters: { dateToWeekday },
  props: [
    'start',
    'end'
  ]
};
</script>
